import { Injectable, signal, afterRenderEffect } from '@angular/core';
import { LocalstorageConstants } from '@dss-libs/shared/type/common-types';
import { GlobalConstant } from '@dss-libs/portal/type/portal-types';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  readonly #defaultSidebarExtended = true;
  readonly #sidebarExtendedKey = LocalstorageConstants.SIDEBAR_EXTENDED;

  extendLayout = signal(this.#getInitialSidebarExtended());
  isPhoneLayout = signal(false);
  screenWidth = signal(window.innerWidth);
  phoneBreakPoint = GlobalConstant.PHONE_BREAK_POINT;

  writeSidebarStateToLocalStorage = afterRenderEffect(() => {
    window.localStorage.setItem(this.#sidebarExtendedKey, String(this.extendLayout()));
  });

  #getInitialSidebarExtended(): boolean {
    const storedValue = window.localStorage.getItem(this.#sidebarExtendedKey);
    return storedValue !== null ? storedValue === 'true' : this.#defaultSidebarExtended;
  }
}
